import { ERateValues } from '../types/redux/rateOurEstimation';

export const RATES = [
  {
    label: 'Сильно занижена',
    value: ERateValues.TooLow,
  },
  {
    label: 'Занижена',
    value: ERateValues.Low,
  },
  {
    label: 'Завышена',
    value: ERateValues.High,
  },
  {
    label: 'Сильно завышена',
    value: ERateValues.TooHigh,
  },
];
